import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as ROUTES from '../../../constants/routes';
import { connect } from 'react-redux';
import { signUp } from "../../../store/actions/authActions";

const formCheckStyle = {
    fontSize: "12px",
};

const formLabelStyle = {
    fontSize: "12px",
    fontWeight: "bold",
};

class RegisterForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            phone: "",
            address: "",
            profilePic: "",
            agreementCheck: true,
            isShowPassword: false,
        }
    }

    toggleShowPassword = () => {
        var isShowPassword = this.state.isShowPassword;
        this.setState({
            isShowPassword: !isShowPassword
        })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleAgreement = (e) => {
        this.setState({
            [e.target.id]: !this.state.agreementCheck
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.agreementCheck) {
            this.props.signUp(this.state);
        } else {
            console.log("Check agreement for registration!");
        }
    }

    render() {
        const { isShowPassword } = this.state;
        const { error, showLoader } = this.props.auth;
        const {isViaModal,modalTitleStyle} = this.props;
        const relevantSubmitComponent = showLoader && !error ?
            <button className="btn btn-flat btn-dark btn-sm" type="button" disabled>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp; Creating your account
            </button> : <button className="btn btn-dark btn-sm" type="submit">Create my account</button>;

        return (
            <div className="container">
                <div className={isViaModal ? "":"card"}>
                    <p style={modalTitleStyle} className={isViaModal?"":"card-header"}>Create a new account</p>
                    <div className={isViaModal?"":"card-body"}>
                        <form onSubmit={this.handleSubmit}>

                            {/* NAME */}
                            <div className="form-row">
                                <div className="form-group col-md-6 text-left">
                                    <label htmlFor="firstName" style={formLabelStyle}>First name</label>
                                    <input type="text" className="form-control" id="firstName" onChange={this.handleChange} required />
                                </div>
                                <div className="form-group col-md-6 text-left">
                                    <label htmlFor="lastName" style={formLabelStyle}>Last name</label>
                                    <input type="text" className="form-control" id="lastName" onChange={this.handleChange} required />
                                </div>
                            </div>

                            {/* PHONE */}
                            <div className="form-group text-left">
                                <label htmlFor="phone" style={formLabelStyle}>Phone</label>
                                <input type="tel" className="form-control" id="phone" onChange={this.handleChange} placeholder="Hint: +441234567899" pattern="[+]{1}[0-9]{2,}" required />
                            </div>

                            {/* EMAIL AND PASS */}
                            <div className="form-group text-left">
                                <label htmlFor="email" style={formLabelStyle}>Email</label>
                                <input type="email" className="form-control" id="email" onChange={this.handleChange} required />
                            </div>
                            <div className="form-group text-left">
                                <label htmlFor="password" style={formLabelStyle}>Password</label>
                                <input type={isShowPassword ? 'text' : 'password'} className="form-control" id="password" onChange={this.handleChange} placeholder="Hint: Eight characters or more" pattern=".{8,}" required autoComplete="new-password" />
                            </div>
                            <div className="form-group text-right">
                                <span role="button" className="btn btn-link btn-sm" onClick={this.toggleShowPassword}>{isShowPassword ? 'Hide password' : 'Show password'}</span>
                            </div>

                            {/* AGREEMENT */}
                            <br></br>
                            <div className="form-group">
                                <div className="form-check" style={formCheckStyle}>
                                    <input className="form-check-input" type="checkbox" id="agreementCheck" checked={this.state.agreementCheck} onChange={this.handleAgreement} />
                                    <label className="form-check-label" htmlFor="gridCheck">
                                        I accept all <a href="https://www.axibuild.com/terms/assettag-terms/" target="_blank">terms and conditions</a> and have clearly read and understood <a href="https://www.axibuild.com/policies/assettag-privacy-policy/" target="_blank">privacy policies and data rules</a>.
                                    </label>
                                </div>
                            </div>

                            {/* ERROR */}
                            <p style={{ color: "red", fontWeight: "bold", fontSize: "13px" }}>{error ?? ""}</p>

                            {/* SIGN UP BUTTON */}
                            {relevantSubmitComponent}
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // console.log(state.auth)
    return {
        auth: state.auth,
        themeColors: state.theme,
        modalStyles: state.appControl.modalStyles,
        modalTitleStyle: state.appControl.modalTitleStyle,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signUp: (credentials) => dispatch(signUp(credentials))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);